<template>
    <div class="app-container">
        <div class="filter-container">
            <el-input v-model="listQuery.partnerMobile" placeholder="合伙人账户" style="width: 200px" class="filter-item"
                clearable />

            <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
        </div>

        <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" size="small" border fit
            highlight-current-row>
            <el-table-column label="代理名称" align="center" prop="agentName"></el-table-column>

            <el-table-column label="代理用户" align="center" prop="agentUserName"></el-table-column>
            <el-table-column label="代理合伙人用户" align="center" prop="partnerUser"></el-table-column>

            <el-table-column label="现金分红总额" align="center" prop="cashBonus"></el-table-column>
            <el-table-column label="Tbc分红总额" align="center" prop="tbcBonus"></el-table-column>
            <el-table-column label="分红比例" align="center" prop="ration">
                <template slot-scope="scope">
                    {{ scope.row.ration * 100 }}%
                </template>
            </el-table-column>
            <el-table-column align="center" prop="ctdate" label="创建时间">
                <template slot-scope="scope">
                    <i class="el-icon-time" />
                    <span>{{ formatApiDate(scope.row.ctdate) }}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" prop="mddate" label="更新时间">
                <template slot-scope="scope">
                    <i class="el-icon-time" />
                    <span>{{ formatApiDate(scope.row.mddate) }}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="220">
                <template slot-scope="scope">
                    <div class="action-buttons">
                        <el-button size="mini" type="text" class="action-btn"
                            @click="onDialogVisible(scope.row, 'balance')">现金分红</el-button>
                        <el-button size="mini" type="text" class="action-btn"
                            @click="onDialogVisible(scope.row, 'vcoin')">Tbc分红</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-size="listQuery.pageSize" :total="total" background
                layout=" prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>

        <el-dialog title="分红记录详情" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :width="isMobile ? '90%' : '800px'" :modal-append-to-body="true" :append-to-body="true"
            custom-class="subordinate-dialog">
            <el-table v-loading="dialogLoading" :data="dialogList" element-loading-text="Loading" size="small" border
                fit highlight-current-row style="width: 100%" empty-text="暂无数据">
                <el-table-column label="类型" align="center" prop="type">
                    <template slot-scope="scope">
                        {{ getValue(BALANCE_TYPE, Number(scope.row.type)) }}
                    </template>
                </el-table-column>
                <el-table-column label="变更金额" align="center" prop="amount"></el-table-column>
                <el-table-column label="备注" align="center" prop="remark"></el-table-column>
                <el-table-column align="center" prop="ctdate" label="时间">
                    <template slot-scope="scope">
                        <i class="el-icon-time" />
                        <span>{{ formatApiDate(scope.row.ctdate) }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="dialogListQuery.page" :page-size="dialogListQuery.pageSize"
                    :total="dialogTotal" background layout=" prev, pager, next" @size-change="handleDialogSizeChange"
                    @current-change="handleDialogCurrentChange" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getValue, BALANCE_TYPE } from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";
import { getPartnerList, getPartnerAccountList } from "@/api/partner-management.js";

export default {
    name: "withdrawalRecords",
    props: {
        agentDetail: {
            type: Object,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            list: [],
            isMobile: false,
            total: 0,
            listLoading: true,
            listQuery: {
                page: 1,
                pageSize: 10,
                partnerMobile: null
            },

            // 分红记录详情弹窗
            dialogVisible: false,
            dialogListQuery: {
                id: null,
                type: null,
                page: 1,
                pageSize: 10,
            },
            dialogTotal: 0,
            dialogList: [],
            dialogLoading: true,
        };
    },

    mounted() {
        // 初始化时检测设备类型
        this.checkIsMobile();
        // 监听窗口大小变化
        window.addEventListener("resize", this.checkIsMobile);
    },
    beforeDestroy() {
        // 组件销毁前移除事件监听
        window.removeEventListener("resize", this.checkIsMobile);
    },
    created() {

        this.getList();
    },
    methods: {
         getValue,
        formatApiDate,
        // 检测是否为移动设备
        checkIsMobile() {
            this.isMobile = window.innerWidth < 768;
        },

        getList() {
            this.listLoading = false;
            getPartnerList(this.listQuery).then((res) => {
                this.list = res.data.entitys;
                this.total = res.data.totalCount;
                this.listLoading = false;
            });
        },
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },

        async onDialogVisible(row, type = 'balance') {
            this.dialogListQuery = {
                page: 1,
                pageSize: 10,
                category: type,
                id: row.partnerUserId,
            }
            await this.onDialogVisibleList();
            this.$nextTick(() => {
                this.dialogVisible = true;
            });
        },

        async onDialogVisibleList() {
            this.dialogLoading = true;
            await getPartnerAccountList(this.dialogListQuery).then((res) => {
                this.dialogList = res.data.entitys || [];
                this.dialogTotal = res.data.totalCount || 0;
                this.dialogLoading = false;
            }).catch(() => {
                this.dialogList = [];
                this.dialogTotal = 0;
                this.dialogLoading = false;
            })
        },

        // 分红记录详情弹窗搜索
        handleDialogFilter() {
            this.dialogListQuery.page = 1;
            this.onDialogVisibleList();
        },
        handleDialogSizeChange(val) {
            this.dialogListQuery.pageSize = val;
            this.onDialogVisibleList();
        },
        handleDialogCurrentChange(val) {
            this.dialogListQuery.page = val;
            this.onDialogVisibleList();
        },
        closeDialogVisible() {
            this.dialogVisible = false;
        },
    },
    computed: {
        BALANCE_TYPE() {
            return BALANCE_TYPE;
        },
    },

};
</script>

<style scoped lang="scss">
.pagination-container {
    float: none;
    text-align: end;
    margin: 20px 0 0;
}

.action-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
}

.action-btn {
    color: #409eff;
    font-size: 12px;
    padding: 4px 8px;
    margin: 0;

    &:hover {
        color: #66b1ff;
        background-color: rgba(64, 158, 255, 0.08);
        border-radius: 4px;
    }
}
</style>
